module.exports = __webpack_public_path__ + "img/aboutus-banner.a5626d4d.png";